import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Scrolls the window back to the top whenever the route (pathname) changes,
// so every navigation shows the new page from the beginning.
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
